<template>

    <div v-if="trip">
        <div v-show="trip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION">
            <PassengerTripCard :trip="trip"  v-if="trip" class="float-container--top"></PassengerTripCard>
            <div class="float-container--bottom" v-if="!settings.modulo_flujo_tipo_uber">
                <button class="btn btn-primary btn-lg btn-heavy float-container--bottom" v-if="canAdvanceReservation" v-lang.enDestino @click="OnArriveToDestination" >En Destino</button>
            </div>
        </div>
        <div v-show="trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION" class="float-container--bottom card">
            <h2 class="title" v-lang.calificarViaje>Calificar el viaje</h2>
            <div class="row">
                <div class="col-xs-6" v-if="trip.chofer">
                    <img v-imgSrc="profilePic" class="driver-profile-photo" />
                </div>
                <div class="col-xs-18">
                    <div v-if="trip.chofer && trip.chofer.usuario">
                        <div v-lang.chofer>Chofer</div>
                        <div class="text-strong">{{ trip.chofer.usuario.nombre }} {{ trip.chofer.usuario.apellido }}</div>
                    </div>
                </div>
            </div>
            <div class="col-xs-24">
                <p v-lang.comoCalificaria>¿Con cuántas estrellas calificarías el viaje?</p>
                <div class="stars-widget">
                    <button v-for="star in stars" @click="makeQualification(star)" class="btn-qualify col-xs-4_8" :aria-label="'Calificar con ' + star + ' estrellas'">
                        <svg-item :icon="'star'" :color="star <= calificacion ? '--star-filled-background' : '--star-empty-background'"></svg-item>
                    </button>
                </div>
            </div>
            <button class="btn btn-primary btn-lg btn-heavy" v-lang.calificar @click="OnEndTrip">Calificar</button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '@/services/dialogs.js';
import { reservationAdvanceAllowed } from '@/services/reservation';
import PassengerTripCard from './PassengerTripCard.vue';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'passengerOnTrip',
    props: [
    ],
    data () {
        return {
            calificacion: 0,
            stars: [1, 2, 3, 4, 5],
            profilePic: null
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            trip: 'passenger/actualTrip',
            settings: 'company/config',
            position: 'geolocation/actual'
        }),
        canAdvanceReservation () {
            return reservationAdvanceAllowed(this.trip, this.settings);
        }
    },
    mounted () {
        this.language = this.$getLang();
        this.profilePic = this.trip.chofer.foto ? this.$profile(this.trip.chofer.foto) : defaultProfilePic;
    },

    methods: {
        ...mapActions({
            arrivedToDestination: 'passenger/arrivedToDestination',
            endTrip: 'passenger/endTrip'
        }),
        OnArriveToDestination () {
            this.arrivedToDestination();
        },
        OnEndTrip () {
            if (this.calificacion > 0) {
                let data = {
                    lat: this.position ? this.position.lat : 0,
                    lng: this.position ? this.position.lng : 0,
                    calificacion: this.calificacion
                };
                let tripId = this.trip.id;
                let zoneId = this.trip.zona_id;
                this.endTrip(data).then(() => {
                    if (this.settings.modulo_promociones || this.user.tester) {
                        dialogs.confirm(this.translate('deseasElegirPromocion'), (index) => {
                            if (index === 1) {
                                this.$router.push({
                                    path: 'select-promotion/' + zoneId + '/' + tripId
                                });
                            }
                        }, this.translate('promociones'), [this.translate('si'), this.translate('no')]);
                    }
                });
            } else {
                dialogs.message(this.translate('debeCalificar'), { duration: 3, estado: 'error' });
            }
        },
        makeQualification (index) {
            this.calificacion = index;
        }

    },
    components: {
        PassengerTripCard
    }
};
</script>

<style scoped>
    .card .title {
        color: var(--main-color);
        margin-bottom: 1em;
    }
    .col-xs-4_8 {
        width: 20%;
    }
    p {
        margin-bottom: .75rem;
        font-size: 1.1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/OnTrip.vue